module.exports = __webpack_public_path__ + "static/media/bell-icon-blue.ad3aebc3.svg";